// extracted by mini-css-extract-plugin
export var footerElementTitle = "footer-table-menu-module--footerElementTitle--da4da";
export var footerListElement = "footer-table-menu-module--footerListElement--b910f";
export var tableMenu = "footer-table-menu-module--tableMenu--6681e";
export var tableMenuItem = "footer-table-menu-module--tableMenuItem--53e8c";
export var tableMenuLabel = "footer-table-menu-module--tableMenuLabel--38cd6";
export var tableMenuLabelTitle = "footer-table-menu-module--tableMenuLabelTitle--914a8";
export var tableMenuSubLabel = "footer-table-menu-module--tableMenuSubLabel--e15a9";